import i18n, { TranslateArg } from 'helpers/i18n';
import messages from './messages';
import { useMeasure } from 'context/measure';

export const answersBox =
  'grid grid-cols-3 items-start justify-items-center self-center w-3/4 mx-auto font-bold text-[15px] lg:mx-0 lg:w-[360px]';
export const labelsBox = 'h-6 text-center whitespace-nowrap';
/** Second edition PK-3rd cycles label the scale with words instead of numbers. */
type ChoiceLabel = TranslateArg[];
const TIME_LABELS: ChoiceLabel = [
  messages.howMuchTime.none,
  messages.howMuchTime.some,
  messages.howMuchTime.most
];
const CHILDREN_LABELS: ChoiceLabel = [
  messages.howManyChildren.few,
  messages.howManyChildren.some,
  messages.howManyChildren.many
];
const ENGAGEMENT_LABELS: ChoiceLabel = [
  messages.howActive.disengaged,
  messages.howActive.mixed,
  messages.howActive.active
];

const WORD_LABELS: Record<string, ChoiceLabel> = {
  how_much_time: TIME_LABELS,
  how_many_children: CHILDREN_LABELS,
  how_active: ENGAGEMENT_LABELS
};
const NUMBER_LABELS: string[] = ['1', '2', '3'];

export function useIsSecondEditionPk3rd() {
  const { assessment } = useMeasure();

  return (
    assessment.age_level === 'PK-3rd' &&
    assessment.assessment_template.class_version === 2
  );
}

interface LabelsBoxProps {
  questionTName?: string;
  questionId?: number;
  choiceId?: number;
}

function LabelsBox({ questionTName, questionId, choiceId }: LabelsBoxProps) {
  const isSecondEditionPk3rd = useIsSecondEditionPk3rd();

  // Second Edition PK-3rd uses question-specific word labels. Hide the category-level
  // label row since each question will display its own labels.
  if (isSecondEditionPk3rd && !questionTName) {
    return null;
  }

  let labels: string[] = [];
  if (!isSecondEditionPk3rd) {
    labels = NUMBER_LABELS;
  } else {
    // `t_name` is a full i18n key, so only its last segment identifies the question.
    const questionName = questionTName?.split('.').pop() ?? '';
    const wordLabels = WORD_LABELS[questionName] ?? NUMBER_LABELS;
    labels = wordLabels.map(label => i18n.ft(label));
  }
  return (
    <div className={answersBox}>
      {labels.map((label, index) => {
        const inputId =
          questionId && choiceId
            ? `q${questionId}_c${choiceId}_${index + 1}`
            : undefined;

        return inputId ? (
          <label
            key={label}
            htmlFor={inputId}
            className={`${labelsBox} cursor-pointer`}
          >
            {label}
          </label>
        ) : (
          <div key={label} className={labelsBox}>
            {label}
          </div>
        );
      })}
    </div>
  );
}

export default LabelsBox;
